import { sheetFont } from "./sheetFont";

export const addNoteRow = (worksheet, rowNumber, text) => {
  const noteRow = worksheet.getRow(rowNumber);
  let noteCell = noteRow.getCell("A");
  noteCell.value = text;
  noteCell.font = sheetFont(true);
};
